import React from "react";
import { GET_LIST, Title, Link } from "react-admin";
import { Card, CardContent, Grid, Paper, Button } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import { filter, path, map, trim, prop, isNil, sortBy, range } from "ramda";
import { connect } from "react-redux";
import LinearProgress from "@material-ui/core/LinearProgress";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Add from "@material-ui/icons/Add";
import moment_tz from 'moment-timezone';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ReactToPrint from "react-to-print";
import Print from "@material-ui/icons/Print";

moment_tz.tz.setDefault("Europe/Madrid");
const MonthHeader = styled.div`
  text-align: center;
  padding: 0.2em;
  font-weight: bold;
  text-transform: uppercase;
`;

const TransferCard = styled.div`
  padding: 1em;
`;

const StyledSpan = styled.span`
  color: ${props => {
    return props.past === "true" ? "#aaaaaa" : "#000000";
  }};
  &:hover {
    color: #ff9800 !important;
  }
`;

const StyledLink = styled(Link)`
  color: ${props => {
    return props.past === "true" ? "#aaaaaa" : "";
  }};
`;

const DateHeader = styled.div`
  text-align: center;
  border-top: 2px solid #000000;
  padding-top: 5px;
  color: ${props => {
    return props.past === "true" ? "#aaaaaa" : "#000000";
  }};
`;

const LocationHeader = styled.div`
  display: flex;
  padding: 0.2em;
`;
const Location = styled.div`
  text-align: center;
  flex-grow: 1;
  background-color: ${props => props.color};
  color: ${props => {
    return props.past === "true" ? "#aaaaaa" : "#000000";
  }};
`;
const VehicleRow = styled.div`
  flex-grow: 1;
  font-size: 14px;
  padding: 0.2em;
  border-bottom: 1px solid #000000;
  color: ${props => {
    return props.past === "true" ? "#aaaaaa" : "#000000";
  }};
`;

const GpsRow = styled.div`
  flex-grow: 1;
  font-size: 14px;
  padding: 0.2em;
  border-bottom: 1px solid #000000;
  color: ${props => {
    return props.past === "true" ? "#aaaaaa" : "#000000";
  }};
`;

const CommentRow = styled.div`
  flex-grow: 1;
  font-size: 14px;
  padding: 0.2em;
  border-bottom: 1px solid #000000;
  color: ${props => {
    return props.past === "true" ? "#aaaaaa" : "#000000";
  }};
`;

const MonthColumnPrint = styled(Paper)`
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 25%;
`;

const StyleDivWithPrint = styled.div`
  display: flex;
`;

class Whiteboard extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }
  async fetchData(start, end) {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_LIST, "transfers", {
      filter: {
        from: start.format("YYYYMMDD"),
        to: end.format("YYYYMMDD")
      },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: "transfer_date", order: "ASC" }
    });

    return response.data;
  }

  async componentDidMount() {
    const today = moment();
    await this.updateStateForMonth(today);
  }

  getTimeInterval = date => ({
    start: date
      .clone()
      .subtract(1, "months")
      .startOf("month"),
    end: date
      .clone()
      .add(2, "months")
      .endOf("month")
  });

  updateStateForMonth = async month => {
    const { start, end } = this.getTimeInterval(month);
    const transfers = await this.fetchData(start, end);
    this.setState({ month, transfers });
  };

  nextClick = async () => {
    const month = (this.state.month || moment()).clone().add(1, "months");
    await this.updateStateForMonth(month);
  };

  backClick = async () => {
    const month = (this.state.month || moment()).clone().subtract(1, "months");
    await this.updateStateForMonth(month);
  };

  itemOnFuture = date => {
    const isFuture =
      moment(date, "YYYY-MM-DD").isAfter(moment(moment(), "YYYY-MM-DD")) ||
      moment(date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD");

    return !isFuture ? "true" : "false";
  };

  renderVehicleRow = (v, p) => {
    return (
      <VehicleRow key={v.id} past={p}>
        <span>{path(["model", "model_name"], v)}</span>
        ,&nbsp;
        <span>{path(["licence_plate"], v)}</span>
        ,&nbsp;
        <span>{path(["vehicle_color"], v)}</span>
      </VehicleRow>
    );
  };

  renderSeatRow = (v, p) => {
    return (
      <GpsRow key={v.id} past={p}>
        <span>{path(["model"], v)}</span>
        ,&nbsp;
      </GpsRow>
    );
  };

  renderJacketRow = (v, p) => {
    return (
      <GpsRow key={v.id} past={p}>
        <span>
          {path(["model"], v)} ({path(["size"], v)})
        </span>
        ,&nbsp;
      </GpsRow>
    );
  };

  renderHelmetRow = (v, p) => {
    return (
      <GpsRow key={v.id} past={p}>
        <span>
          {path(["model"], v)} ({path(["size"], v)})
        </span>
        ,&nbsp;
      </GpsRow>
    );
  };

  renderGloveRow = (v, p) => {
    return (
      <GpsRow key={v.id} past={p}>
        <span>{path(["model"], v)}</span>
        ,&nbsp;
      </GpsRow>
    );
  };

  renderTabkbag = (v, p) => {
    return (
      <GpsRow key={v.id} past={p}>
        <span>
          {path(["model"], v)} - {path(["type"], v)} (
          {path(["vehicle_model", "model_name"], v)})
        </span>
        ,&nbsp;
      </GpsRow>
    );
  };

  renderGpsRow = (v, p) => {
    return (
      <GpsRow key={v.id} past={p}>
        <span>{path(["model"], v)}</span>
      </GpsRow>
    );
  };

  renderCommentRow = (t, p) => {
    const permissions = JSON.parse(localStorage.getItem("permissions"));
    const notes = prop("notes", t);
    if (!isNil(permissions) && prop("isAdmin", permissions)) {
    if (!isNil(notes)) {
      return (
        <CommentRow key={t.id} past={p}>
          <Link
            past={p.toString()}
            to={{ pathname: `/transfers/${t.id}` }}
            target="_blank"
          >
            <StyledSpan past={p}>{notes}</StyledSpan>
          </Link>

          
        </CommentRow>

        
      );
    }
  }
  else{
    if (!isNil(notes)) {
      return (
        <CommentRow key={t.id} past={p}>
          
            <StyledSpan past={p}>{notes}</StyledSpan>
         

          
        </CommentRow>

        
      );
    }
  }
};

  renderMonthComponent = t => {
    const onFuture = this.itemOnFuture(t.transfer_date);
    return (
      <TransferCard key={t.id}>
        <DateHeader>
          <StyledLink
            past={onFuture.toString()}
            to={{ pathname: `/transfers/${t.id}` }}
          >
            {moment(t.transfer_date).format("dddd DD-MM-YYYY")}
          </StyledLink>
        </DateHeader>
        <LocationHeader>
          <Location
            past={onFuture.toString()}
            color={trim(path(["location_1", "color"], t))}
          >
            {path(["location_1", "location_name"], t)}
          </Location>
          <Location
            past={onFuture.toString()}
            color={trim(path(["location_2", "color"], t))}
          >
            {path(["location_2", "location_name"], t)}
          </Location>
        </LocationHeader>
        {this.renderCommentRow(t, onFuture.toString())}
        {map(item => {
          return this.renderVehicleRow(item, onFuture.toString());
        }, sortBy(path(["model", "order"]), t.vehicles))}
        {map(item => {
          return this.renderGpsRow(item, onFuture.toString());
        }, sortBy(prop("id"), t.gps_devices))}
        {map(item => {
          return this.renderSeatRow(item, onFuture.toString());
        }, t.seats)}
        {map(item => {
          return this.renderJacketRow(item, onFuture.toString());
        }, t.jackets)}
        {map(item => {
          return this.renderTabkbag(item, onFuture.toString());
        }, t.tankbags)}
        {map(item => {
          return this.renderHelmetRow(item, onFuture.toString());
        }, t.helmets)}
        {map(item => {
          return this.renderGloveRow(item, onFuture.toString());
        }, t.gloves)}
      </TransferCard>
    );
  };

  renderMonthColumn = month => {
    const isSameMonth = t => month.isSame(moment(t.transfer_date), "month");
    const monthTransfers = filter(isSameMonth, this.state.transfers);
    return map(this.renderMonthComponent, monthTransfers);
  };

  renderMonthColumnHeader = date => (
    <MonthHeader>{date.format("MMMM")}</MonthHeader>
  );

  handleChangeMonth = async event => {
    this.month = event.target.value;
    this.setState({ loading: true });
    this.updateStateForMonth(moment(this.month), this.state.currentLocation);
  };

  render() {
    if (this.state === null) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const month = this.state.month;

    const months = [
      month.clone().subtract(1, "months"),
      month.clone(),
      month.clone().add(1, "months"),
      month.clone().add(2, "months")
    ];

    let begining = moment().startOf("month");
    const recordForMonth = month => ({
      id: month.format("YYYY-MM-DD"),
      label: month.format("MMMM YYYY")
    });

    let monthsSelect = map(
      offset => recordForMonth(begining.clone().add(offset, "month")),
      range(-24, 24)
    );
    const permissions = JSON.parse(localStorage.getItem("permissions"));
    return (
      <Card>
               {((!isNil(permissions) && prop("isAdmin", permissions)) ||
              prop("isManager", permissions)) && (
                <Button color="primary" onClick={this.addClick} title="Create Transfer">
                <a href={"#/transfers/create"}>
                  <Add />
                </a>
              </Button>
   )}
      
        <Button color="primary" onClick={this.backClick} title="Back">
          <ChevronLeft />
        </Button>
        <Button color="primary" onClick={this.nextClick} title="Forward">
          <ChevronRight />
        </Button>
        <Title title="Transfers" />
        <React.Fragment>{ }</React.Fragment>
        <FormControl style={{ paddingLeft: "30px" }}>
          <Select
            value={this.state.month.startOf("month").format("YYYY-MM-DD")}
            onChange={this.handleChangeMonth}
            inputProps={{
              name: "month",
              id: "month-simple"
            }}
          >
            {map(month => {
              return (
                <MenuItem key={month.id} value={month.id}>
                  {month.label}
                </MenuItem>
              );
            }, monthsSelect)}
          </Select>
        </FormControl>
        {/* <ReactToPrint
          trigger={() => (
            <Button color="primary" onClick={this.nextClick} title="Print">
              <Print />
            </Button>
          )}
          content={() => this.componentRef.current}
        /> */}
        <CardContent>
          <StyleDivWithPrint ref={this.componentRef}>
            <MonthColumnPrint>
              {this.renderMonthColumnHeader(months[0])}
              {this.renderMonthColumn(months[0])}
            </MonthColumnPrint>
            <MonthColumnPrint>
              {this.renderMonthColumnHeader(months[1])}
              {this.renderMonthColumn(months[1])}
            </MonthColumnPrint>
            <MonthColumnPrint>
              {this.renderMonthColumnHeader(months[2])}
              {this.renderMonthColumn(months[2])}
            </MonthColumnPrint>
            <MonthColumnPrint>
              {this.renderMonthColumnHeader(months[3])}
              {this.renderMonthColumn(months[3])}
            </MonthColumnPrint>
          </StyleDivWithPrint>
        </CardContent>
      </Card>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    state: state
  };
};

export default connect(mapStateToProps)(Whiteboard);



// WEBPACK FOOTER //
// ./src/components/whiteboard.js